import React from 'react';
import cx from 'classnames';
export function LoadingIcon(props) {
    var className = props.className, fontSize = props.style.fontSize, prefixCls = props.prefixCls, colorConfig = props.colorConfig;
    return (React.createElement("svg", { className: cx(className, "".concat(prefixCls, "-icon")), width: fontSize, height: fontSize, viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { className: "".concat(prefixCls, "-icon-color-").concat(colorConfig.type), d: "M15 28C22.1797 28 28 22.1797 28 15C28 7.8203 22.1797 2 15 2C7.8203 2 2 7.8203 2 15", strokeWidth: "3", stroke: colorConfig.color })));
}
